import { Routes } from '@angular/router';
import { authRoutes } from './auth/auth-routes';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'survey/:surveyInfo',
    loadComponent: () =>
      import('./pages/participants-view/components/test-component/test-component.component').then(
        (c) => c.TestComponentComponent,
      ),
  },
  {
    path: '',
    loadChildren: () => import('./core/main/main.routes').then((r) => r.mainRoutes),
    canActivate: [AuthGuard],
  },
  ...authRoutes,
  { path: '**', redirectTo: '' },
];
